import React, { Component } from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// REACT-SELECT COMPONENTS
import { components } from 'react-select';

// CORE COMPONENTS
import Addon from 'core/form/parts/Addon';

// STYLES
import styles from '../select.module.scss';
import inputStyles from '../../../parts/input.module.scss';

// MAIN COMPONENT
// eslint-disable-next-line react/prefer-stateless-function
class ValueContainer extends Component {
  render() {
    return (<>
      {this.props.selectProps.prepend && !this.props.isDisabled &&
        <Addon
          className={clsx(
            'value-container',
            styles.addon,
            styles.prepend,
            styles[this.props.selectProps.size],
            this.props.className
          )}
          {...(this.props.selectProps.prepend || {})}
          size={this.props.selectProps.size}
          prepend
        />
      }
      <components.ValueContainer {...this.props} className={clsx(
        'form-control',
        inputStyles.control,
        styles.valueContainer,
        styles[this.props.selectProps.size],
        this.props.className
      )} />
    </>)
  }
}

// EXPORT
export default ValueContainer
